import React from "react"
import { getFormValues } from "redux-form"
import { connect } from "react-redux"
import "components/style.scss"
import PhoneArea from "components/PhonePreview/PhoneArea"
import { FORM_NAMES } from "constants/index"

const InAppMessagePreview = ({ notificationValues = {} }) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundColor: "white",
          width: "105%",
          height: "105%",
          marginLeft: "-5px",
        }}
      >
        <div className="in-app-message">
          <div className="header" style={{ marginLeft: "-5px" }}>
            <span>Messages</span>
          </div>

          {/* subject */}
          <div className="subject">
            <span className="colored">Subject: </span>
            <span>{notificationValues?.subject}</span>
          </div>

          {/* message */}
          <div className="message">
            <span className="colored">Message: </span>
            <span>{notificationValues?.message}</span>
          </div>
        </div>
      </div>
    </PhoneArea>
  )
}

const mapStateToProps = state => ({
  notificationValues: getFormValues(FORM_NAMES.NOTIFICATION)(state),
})

export default connect(mapStateToProps)(InAppMessagePreview)
